import { render, staticRenderFns } from "./GameScroll.vue?vue&type=template&id=1ee909a6&"
import script from "./GameScroll.vue?vue&type=script&lang=js&"
export * from "./GameScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports